import { Text } from '@/components/text';
import { VehicleDelayStatus } from '@/components/vehicle-delay-status';
import { VehicleDelayInterface } from '@/types';
import { formatDelayStatusLabel } from '@/utils/strings';

interface Props {
  delay?: VehicleDelayInterface;
}

const VehicleDelayTooltip = ({ delay }: Props) => {
  const hasStatus = !!delay?.status;

  return (
    <div className="flex items-center">
      {hasStatus && <VehicleDelayStatus delay={delay} />}
      <Text className="m-0 text-sm">{formatDelayStatusLabel(delay)}</Text>
    </div>
  );
};

export { VehicleDelayTooltip };
